import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  activeDocument: null,
  tools: [],
  loadingTools: true,
  documentContext: "",
  attachmentTarget: null,
  chatOpen: false,
  newCode: null,
}

const editorSlice = createSlice({
  name: "editorSlice",
  initialState: initialState,
  reducers: {
    reset() {
      return initialState;
    },
    toggleChat(state) {
      state.chatOpen = !state.chatOpen;
    },
    setAttachmentTarget(state, action) {
      state.attachmentTarget = action.payload;
    },
    initializeTools(state, action) {
      const tools = action.payload;
      state.tools = tools;
      state.loadingTools = false;
    },
    updateActiveDocument(state, action) {
      state.activeDocument.content = action.payload;
    },
    setActiveDocument(state, action) {
      state.activeDocument = action.payload;
    },
    setDocumentContext(state, action) {
      state.documentContext = action.payload;
    },
  }
});

export const editorActions = editorSlice.actions;

export default editorSlice.reducer;